import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getMyPortfolioAdverts, getMLSPotentialAdverts, getIncomingMLSRequst, getOutcomingMLSRequst, getMLSStoreFilter } from "./Services";





export const useGetMLSStores= (filter:any) => {
  return useQuery(
    [endpoints.getMLSStoreFilter,filter],
    () => getMLSStoreFilter(filter),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};

export const useGetMyPortfolioAdverts = (filter: any) => {
  return useQuery(
    [endpoints.getMyPortfolioAdverts, filter],
    () => getMyPortfolioAdverts(filter),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};

export const useGetMLSPotentialAdverts = (filter: any) => {
  return useQuery(
    [endpoints.getPotentialAdverts, filter],
    () => getMLSPotentialAdverts(filter),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};


export const useGetIncomingMLSRequst = (filter: any) => {
  return useQuery(
    [endpoints.getIncomingMLSRequst, filter],
    () => getIncomingMLSRequst(filter),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};


export const useGetOutcomingMLSRequst = (filter: any) => {
  return useQuery(
    [endpoints.getOutcomingMLSRequst, filter],
    () => getOutcomingMLSRequst(filter),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};


